import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export default function ErrorState({
  title = 'Não foi possível carregar os dados',
  description = 'Verifique sua conexão e tente novamente.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center rounded-lg border border-red-200 bg-red-50 px-6 py-10 text-center">
      <AlertTriangle className="mb-3 h-10 w-10 text-red-400" aria-hidden />
      <p className="text-base font-semibold text-red-700">{title}</p>
      <p className="mt-1 max-w-lg text-sm text-red-600">{description}</p>
      {onRetry ? (
        <Button variant="outline" className="mt-4 border-red-300 bg-transparent" onClick={onRetry}>
          Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
